import * as questionApi from './http/question';
import * as experApi from './http/expert';
import * as classroomApi from './http/classroom';
import * as wikiApi from './http/wiki';


// 各个模块哒api
export default {
    questionApi,
    experApi,
    classroomApi,
    wikiApi
    
}



// WEBPACK FOOTER //
// ./src/api/compose.js